module.exports = __webpack_public_path__ + "img/GREEN_YELLOW_80X30.00bc47b7.png";